<template>
  <div>
    <div id="monitoramento">
      <div class="row">
        <div class="col-md-12">
          <vuestic-widget>
            <div class="row cabecalho">
              <div class="col-12">
                <ul class="nav nav-fill">
                  <li class="nav-item">
                    <strong> AutoEscola </strong>
                    <br />
                    <span>{{ schema.replace('autoescola', 'auto escola ').toUpperCase() }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Sala </strong>
                    <br />
                    <span>{{ aula.salass.id_sala }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Quantidade de Alunos </strong>
                    <br />

                    <span>{{ alunos.length }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Horario </strong>
                    <br />
                    <span> {{ horario(aula.inicio,aula.fim)  }} </span>
                  </li>
                  <li class="nav-item">
                    <strong> Materia </strong>
                    <br />
                    <span>{{ aula.materia.titulo }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Card do Instrutor -->
            <div class="scroll" v-if="instrutor">
              <div class="card text-center" style="width: 200px">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-12">
                      <p style="white-space: normal">
                        {{ nome(instrutor.nome) }}
                      </p>
                      <p style="white-space: normal">
                      <img class="col-md-12" id="img_instrutor" :src="aula.imagem" alt=""/>
                      </p>
                    </div>
                  </div>
                  <h6>Instrutor</h6>
                  <div class="row" style="justify-content: center">
                    <div class="col-sm-12">
                      <table class="table-responsive-sm">
                        <tr>
                          <td>Fotos tiradas:</td>
                          <td v-if="instrutor.fotos">
                            {{ instrutor.fotos.length }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 2px">
                  <div class="col-md-12">
                    <span class="badge badge-danger">
                      <span
                        @click="imageStatusTodosInstrutor(2)"
                        aria-hidden="true"
                        class="fa fa-user-times"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span>
                    <span class="badge badge-danger">
                      <span
                        @click="imageStatusTodosInstrutor(1)"
                        aria-hidden="true"
                        class="fa fa-low-vision"
                        style="font-size: 16px; padding-left: 2px"
                      ></span>
                    </span>

                    <span class="badge badge-warning">
                      <span
                        @click="imageStatusTodosInstrutor(3)"
                        aria-hidden="true"
                        class="fa fa-exclamation-triangle"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>

                    <span class="badge badge-success">
                      <span
                        @click="imageStatusTodosInstrutor(4)"
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="card text-center"
                style="width: 140px"
                v-for="(foto, index) in instrutor.fotos"
                :key="'instrutor_' + foto.id_foto_teorica + index"
              >
                <!-- <div class="row"> -->
                <!-- <div class="col-sm-12"> -->
                <img
                  v-if="foto.id_status === 1"
                  class="card-img-top"
                  width="200px"
                  height="173px"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  alt="Imagem"
                  :id="
                    'foto_' + foto.id_foto_teorica + '_' + instrutor.nome + '_1'
                  "
                  style="border: solid 5px rgb(255, 0, 0)"
                />
                <!-- foto_2_0_1 -->

                <img
                  v-else-if="foto.id_status === 2"
                  class="card-img-top"
                  width="200px"
                  height="173px"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  alt="Imagem"
                  :id="'foto_' + foto.id_foto_teorica + '_' + instrutor + '_2'"
                  style="border: solid 5px rgb(255, 0, 0)"
                />

                <img
                  v-else-if="foto.id_status === 3"
                  class="card-img-top"
                  width="200px"
                  height="173px"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  alt="Imagem"
                  :id="'foto_' + foto.id_foto_teorica + '_' + instrutor + '_3'"
                  style="border: solid 5px rgb(255, 251, 0)"
                />

                <img
                  v-else-if="foto.id_status === 4"
                  class="card-img-top"
                  width="200px"
                  height="173px"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  alt="Imagem"
                  :id="'foto_' + foto.id_foto_teorica + '_' + instrutor + '_5'"
                  style="border: solid 5px rgb(9, 255, 0)"
                />

                <img
                  v-else
                  class="card-img-top"
                  width="200px"
                  height="173px"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  alt="Imagem"
                  :id="'foto_' + foto.id_foto_teorica + '_' + instrutor"
                />

                <div class="row">
                  <div class="col-md-12">
                    {{ tempo(foto.tempo) }}
                  </div>
                </div>

                <!-- </div> -->
                <!-- </div> -->

                <div class="row">
                  <div class="col-md-12">
                    <span class="badge badge-danger">
                      <span
                        @click="imageStatusInstrutor(index, 2)"
                        aria-hidden="true"
                        class="fa fa-user-times"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span>
                    <span class="badge badge-danger">
                      <span
                        @click="imageStatusInstrutor(index, 1)"
                        aria-hidden="true"
                        class="fa fa-low-vision"
                        style="font-size: 16px; padding-left: 2px"
                      ></span>
                    </span>
                    <span class="badge badge-warning">
                      <span
                        @click="imageStatusInstrutor(index, 3)"
                        aria-hidden="true"
                        class="fa fa-exclamation-triangle"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                    <span class="badge badge-success">
                      <span
                        @click="imageStatusInstrutor(index, 4)"
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fim do Card do Instrutor -->
            <!-- <div class="row text-center"> -->
            <!-- Card do Aluno -->
            <div
              class="scroll"
              v-for="(aluno, index) in alunos"
              :key="'aluno_' + aluno.id_aluno"
              :id="'aluno_' + aluno.id_aluno"
            >
              <div class="card text-center" style="width: 200px">
                <div class="container">
                  <p>{{ nome(aluno.nome) }}</p>
                  <p>
                   <img class="col-md-12" :src="aluno.imagem" alt="" />
                  </p>
                  <h6>{{ aluno.cpf }}</h6>
                  <h6>Aluno</h6>

                  <div class="row" style="justify-content: center">
                    <div class="col-sm-12">
                      <table class="table-responsive-sm">
                        <tr>
                          <td>Fotos tiradas:</td>
                          <td v-if="aluno.fotos">{{ aluno.fotos.length }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="aviso">
                  <div class="col-md-12">
                    <span
                      title="Nenhum aluno detectado"
                      class="badge badge-danger"
                      @click="imageStatusTodos(index, 2)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-user-times"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span>

                    <span
                      title="Sem imagem"
                      class="badge badge-danger"
                      @click="imageStatusTodos(index, 1)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-low-vision"
                        style="font-size: 16px; padding-left: 2px"
                      ></span>
                    </span>

                    <span
                      title="Imagem com erro"
                      class="badge badge-warning"
                      @click="imageStatusTodos(index, 3)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-exclamation-triangle"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>

                    <span
                      title="Imagem OK"
                      class="badge badge-success"
                      @click="imageStatusTodos(index, 4)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                    
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-md-12">
                    <span
                      title="Nenhum aluno detectado"
                      class="badge badge-danger"
                      @click="avisar()"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-user-times"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span>

                    <span
                      title="Sem imagem"
                      class="badge badge-danger"
                      @click="avisar()"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-low-vision"
                        style="font-size: 16px; padding-left: 2px"
                      ></span>
                    </span>

                    <span
                      title="Imagem com erro"
                      class="badge badge-warning"
                      @click="avisar()"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-exclamation-triangle"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>

                    <span
                      title="Imagem OK"
                      class="badge badge-success"
                      @click="avisar()"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                    <span
                      title="Notificar aluno"
                      class="badge badge-warning"
                      @click="notificarAluno(index)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-bell"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="card text-center"
                style="width: 10.94rem"
                v-for="(foto, index) in aluno.fotos"
                :key="'foto_' + foto.id_foto_teorica + '_' + index"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <img
                      v-if="foto.id_status === 1"
                      class="card-img-top"
                      width="200px"
                      height="173px"
                      :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                      alt="Imagem"
                      :id="
                        'foto_' +
                        foto.id_foto_teorica +
                        '_' +
                        aluno.id_aluno +
                        '_1'
                      "
                      style="border: solid 5px rgb(255, 0, 0)"
                    />
                    <!-- foto_2_0_1 -->

                    <img
                      v-else-if="foto.id_status === 2"
                      class="card-img-top"
                      width="200px"
                      height="173px"
                      :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                      alt="Imagem"
                      :id="
                        'foto_' +
                        foto.id_foto_teorica +
                        '_' +
                        aluno.id_aluno +
                        '_2'
                      "
                      style="border: solid 5px rgb(255, 0, 0)"
                    />

                    <img
                      v-else-if="foto.id_status === 3"
                      class="card-img-top"
                      width="200px"
                      height="173px"
                      :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                      alt="Imagem"
                      :id="
                        'foto_' +
                        foto.id_foto_teorica +
                        '_' +
                        aluno.id_aluno +
                        '_3'
                      "
                      style="border: solid 5px rgb(255, 251, 0)"
                    />

                    <img
                      v-else-if="foto.id_status === 4"
                      class="card-img-top"
                      width="200px"
                      height="173px"
                      :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                      alt="Imagem"
                      :id="
                        'foto_' +
                        foto.id_foto_teorica +
                        '_' +
                        aluno.id_aluno +
                        '_5'
                      "
                      style="
                        border: solid 5px rgb(9, 255, 0);
                        border-radius: 2%;
                      "
                    />

                    <img
                      v-else
                      class="card-img-top"
                      width="200px"
                      height="173px"
                      :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                      alt="Imagem"
                      :id="
                        'foto_' + foto.id_foto_teorica + '_' + aluno.id_aluno
                      "
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    {{ tempo(foto.tempo) }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <!-- <span
                      title="Remover foto do aluno"
                      class="badge badge-danger"
                      @click="imageRemove(aluno, index)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-file-image-o"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span> -->

                    <span
                      title="Nenhum aluno detectado"
                      class="badge badge-danger"
                      @click="imageStatus(aluno, index, 2, true)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-user-times"
                        style="font-size: 16px; padding-left: 6px"
                      ></span>
                    </span>

                    <span
                      title="Sem imagem"
                      class="badge badge-danger"
                      @click="imageStatus(aluno, index, 1, true)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-low-vision"
                        style="font-size: 16px; padding-left: 2px"
                      ></span>
                    </span>

                    <span
                      title="Imagem com erro"
                      class="badge badge-warning"
                      @click="imageStatus(aluno, index, 3, true)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-exclamation-triangle"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>

                    <span
                      title="Imagem OK"
                      class="badge badge-success"
                      @click="imageStatus(aluno, index, 4, true)"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-check"
                        style="font-size: 16px; padding-left: 3px"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fim card aluno -->
            <!-- </div> -->
            <vuestic-modal
              id="modal-user-info"
              ref="avisar"
              :cancelClass="'none'"
              :okClass="'none'"
              :closeIconShown="true"
              :large="false"
            >
              <div class="row text-center">
                <div class="col-sm-12">
                  <h3>Aviso</h3>
                  <p>
                    Para classificar as fotos individulamente click primeiro no
                    card.
                  </p>
                </div>
              </div>
            </vuestic-modal>
          </vuestic-widget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeoricasController from './TeoricasController'
import urlApi from '../../../router/urlApi'
import urlApiV2 from '../../../router/urlApiV2'

export default {
  data () {
    return {
      salaId: this.$route.params.id,
      schema: this.$route.params.schema,
      cfc: this.$route.params.cfc,
      aula: [],
      instrutor: [],
      alunos: [],
      aluno: '',
      entidades: [],
      alunoModal: 0,
      alunoModalCheck: false,
      aviso: false,
      ultimo: 0,
      timeout: null,
    }
  },
  mounted () {
    this.atualizar()
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
    console.log('fechou a tela ' + this.timeout)
  },

  methods: {
    atualizar () {
       let self = this
      this.$http.get(urlApi + '/aulas/teoricas/' + this.schema +  '/sala/' + this.salaId)
        .then((response) => {
          this.aula = response.body.dados.aula
          this.alunos = response.body.dados.alunos
          this.instrutor = this.aula.instrutor
          TeoricasController.getFotoInstrutor((response) => {
            this.aula.imagem = "data:image/jpeg;base64," + response.dados
             document.getElementById('img_instrutor').src = this.aula.imagem
            }, this.instrutor.id_instrutor, this.schema)
          this.getFotoAluno()
        })
          .catch((response) => {})

          this.timeout = setTimeout(function () {
            self.atualizar()
          }, 60000)
    },
    getFotoAluno () {
      for (let aluno = 0; aluno < this.alunos.length; aluno++){
       TeoricasController.getFotoAluno((response) => {
            this.$set(this.alunos[aluno], 'imagem', "data:image/jpeg;base64," + response.dados)

          }, this.alunos[aluno].id_aluno, this.schema)
      }
    },
    avisar () {
      let self = this
      self.$refs.avisar.open()
      this.aviso = true
    },
    openModal (idAluno) {
      let self = this
      self.alunoModal = idAluno
      self.alunoModalCheck = true
      self.$refs.smallModal.open()
    },
    openModalInstrutor (idInstrutor) {
      let self = this
      self.InstrutorModalCheck = true
      self.$refs.smallModalInstrutor.open()
    },
    mostrar (elemento, event) {
      let el = document.getElementById(elemento)
      if (el.style.display === 'block') el.style.display = 'none'
      else el.style.display = 'block'
    },

    imageStatus (aluno, key, type, canvas = true) {
      // let self = this

      let idFoto = aluno.fotos[key].id_foto_teorica

      TeoricasController.updateFoto(idFoto, type)

      aluno.fotos[key].id_status = type
    },

    imageRemove(aluno, key) {
      const id_aula_teorica = this.sala.aula.aula.id_aula_teorica;
      const id_turma_teorica = this.sala.aula.aula.id_turma_teorica;
      const cfc = this.sala.cfc;
      const idFoto = aluno.fotos[key].id_foto_teorica;
      const instanciaVue = this;

      TeoricasController.removeFoto(instanciaVue, cfc, id_turma_teorica, id_aula_teorica, idFoto);
    },

    imageStatusInstrutor (key, type) {
      let idFoto = this.instrutor.fotos[key].id_foto_teorica

      TeoricasController.updateFoto(idFoto, type)

      this.instrutor.fotos[key].id_status = type
    },

    imageStatusTodosInstrutor (type) {
      let idInstrutor = this.instrutor.id_instrutor

      TeoricasController.updateFotoEntidadeInstrutor(
        idInstrutor,
        type,
        this.aula.id_aula_teorica
      )

      this.instrutor.fotos.forEach((foto) => {
        foto.id_status = type
      })
    },

    imageStatusTodos (aluno, type) {
      let idAluno = this.alunos[aluno].id_aluno

      TeoricasController.updateFotoEntidade(
        idAluno,
        type,
        this.aula.id_aula_teorica
      )

      this.alunos[aluno].fotos.forEach((foto) => {
        foto.id_status = type
      })
    },
    horario(inicio, fim) {
        var ini = inicio.split(' ')[1];
        var end = fim.split(' ')[1];

        return `De ${ini} ate ${end}`;
    },
    tempo (tempo) {
      return tempo.split(' ')[1]
    },
    nome (nome) {
      return nome.split(' ')[0] + ' ' + nome.split(' ')[1]
    },
    notificarAluno(aluno) {
      let data = {
        cpf: this.alunos[aluno].cpf,
      }
      this.$http.post(urlApiV2 + '/push/notify-student', data).then((response) => {
        console.log(response)
      })
    }
  },
}
</script>

<style scoped>
.aula {
  border: rgb(134, 129, 129) solid 2px;
  border-radius: 2%;
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px;
  /* 5px rounded corners */
  margin: 5px;
  display: inline-block !important;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 4100px;
  border-radius: 10px 10px 0 0;
}
.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 100px;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  position: relative;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}

.scroll {
  overflow: auto;
  white-space: nowrap;
  margin-bottom: 30px;
}

.badge {
  min-width: 2rem !important;
  margin: 0.5px;
  cursor: pointer;
}
</style>
